import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EditIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EditIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M3.6415 22.0005C3.42852 22.0005 3.22068 21.9225 3.05895 21.7784C2.85053 21.5922 2.74347 21.3177 2.77081 21.0398L3.20588 16.6248C3.22466 16.4392 3.30154 16.2644 3.42682 16.1254L12.7335 5.78977C13.0558 5.43101 13.6093 5.40027 13.9686 5.72542L17.8466 9.21733C18.2054 9.54021 18.2344 10.0932 17.911 10.4525L8.60491 20.7881C8.4819 20.9248 8.31846 21.0193 8.13795 21.058L3.82431 21.9811C3.76395 21.9942 3.70244 22.0005 3.6415 22.0005ZM4.91879 17.0827L4.6295 20.0199L7.49501 19.4066L16.026 9.93199L13.4481 7.61032L4.91879 17.0827Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.2327 10.7731C17.0169 10.7731 16.8085 10.6934 16.6473 10.5481L12.7693 7.05623C12.4106 6.73335 12.3815 6.1804 12.705 5.82108L15.4987 2.71812C16.3 1.82749 17.6758 1.7563 18.5664 2.5581L20.5162 4.31259C21.4063 5.11438 21.478 6.49077 20.6762 7.38082L17.8825 10.4838C17.7276 10.6563 17.5101 10.76 17.2783 10.7719C17.2635 10.7725 17.2481 10.7731 17.2327 10.7731ZM14.5899 6.34157L17.1678 8.66324L19.3762 6.21001C19.5328 6.0369 19.5185 5.76868 19.3454 5.61265L17.3956 3.85816C17.2219 3.70213 16.9548 3.71522 16.7982 3.88891L14.5899 6.34157Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default EditIcon;
